import React from 'react';
import Sidebar from './components/sidebar';
import img from "./components/add.png"

// Assuming you already have a Sidebar component
// import Sidebar from './components/Sidebar';

const ProductManagementPage = () => {
  return (
    <div className="flex h-screen bg-gray-100">
      {/* Your existing Sidebar component would go here */}
      <Sidebar />
      
      <div className="flex-1 flex flex-col">
        <main className="flex-1 overflow-auto p-6">
          <h1 className="text-2xl font-semibold text-gray-700 mb-4">Products</h1>
          <hr className="border-gray-300 mb-8" />
          
          <div className="flex  h-full flex-1">
            <div className="w-1/2 pr-8 flex items-left justify-center flex-col pl-[5%]">
              <h2 className="text-5xl font-semibold text-gray-700 mb-4">Add and manage your products</h2>
              <p className="text-gray-600 mb-6">
                Get closer to your sale by adding products, or import your existing products inventory.
              </p>
              
              <div className="flex space-x-4">
                <a href="/admin/view-products" className="bg-white hover:bg-gray-100 text-gray-800 border border-gray-300 py-2 px-4 rounded">
                  View Products
                </a>
                <a  href="/admin/add-products" className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded">
                  Add Products
                </a>
              </div>
            </div>
            
            {/* Right side illustration */}
            <div className="w-1/2 flex items-center justify-center flex-1 ">
              <div className="flex items-center">
                    <img className='w-[200%] scale-[1.2]' src={img} alt='graphics'></img>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ProductManagementPage;